import { Maybe } from 'types/graphqlTypes'
import { formatRate } from 'utils/formatRate'
import { TTierNumber } from '../types'
import { getActiveCommissionTier } from './getActiveCommissionTier'
import { getTierRange } from './getTierRange'

export interface IGetAmountToNextTierProps {
  rate?: Maybe<number>
  tier1Max?: number
  tier2Max?: number
  tier3Max?: number
}

/**
 * Returns the formatted amount needed to reach the next commission tier
 * @example getAmountToNextTier({ rate: 1150, tier1Max: 1100, tier2Max: 1250, tier3Max: 1350 }) // - $50
 */
export const getAmountToNextTier = ({
  rate,
  tier1Max,
  tier2Max,
  tier3Max,
}: IGetAmountToNextTierProps): string | null => {
  if (!rate) {
    return null
  }

  const currentTier = getActiveCommissionTier({ rate, tier1Max, tier2Max, tier3Max })

  if (!currentTier || currentTier === 1) {
    return null
  }

  const nextTier = (currentTier - 1) as TTierNumber
  const nextTierRange = getTierRange({ tierNumber: nextTier, tier1Max, tier2Max, tier3Max })
  const { max: nextTierMax } = nextTierRange || {}

  if (nextTierMax) {
    return `Negotiate down ${formatRate(rate - nextTierMax)} to get to Tier ${nextTier}`
  }

  return null
}
